import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const initialState = {
  open: false,
  title: '',
  description: null,
  onReject: null,
  onConfirm: null,
  okText: 'Proceed',
  cancelText: 'Cancel',
};

/**
 * A higher order component which adds confirm dialog functionality.
 * @param {Component} ComponentToWrap Component to be wrapped
 * @render react
 * @example
 * withConfirm(props => (
 *  <div style={{height: 600}}>
 *    <button onClick={e => {
 *      props.confirm({
 *        title: 'Are you sure?',
 *        description: 'Item will be deleted.',
 *        onConfirm: () => alert('Item deleted')
 *      })
 *    }}>Delete</button>
 *  </div>
 * ))
 */
export function withConfirm(ComponentToWrap) {
  /** Component with confirm dialog. */
  return class WithConfirm extends Component {
    state = {
      ...initialState,
    };

    handleOpen = ({ title, description, onReject = () => {}, onConfirm }) => {
      this.setState({ open: true, title, description, onReject, onConfirm });
    };

    handleAnswer(status) {
      const { onConfirm, onReject } = this.state;
      status ? onConfirm() : onReject();
      this.setState(initialState);
    }

    render() {
      const { title, description, open, cancelText, okText } = this.state;
      return (
        <Fragment>
          <Dialog
            aria-labelledby="responsive-dialog-title"
            fullScreen={false}
            open={open}
            onClose={() => this.handleAnswer(0)}
          >
            <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
            {description ? (
              <DialogContent>
                <DialogContentText>{description}</DialogContentText>
              </DialogContent>
            ) : null}
            <DialogActions>
              <Button color="primary" onClick={() => this.handleAnswer(0)}>
                {cancelText}
              </Button>
              <Button
                autoFocus
                color="primary"
                onClick={() => this.handleAnswer(1)}
              >
                {okText}
              </Button>
            </DialogActions>
          </Dialog>
          <ComponentToWrap {...this.props} confirm={this.handleOpen} />
        </Fragment>
      );
    }
  };
}
